<template>

    <div class="container">
        <header-com>
          <div class="title-ds">
                评价
            </div>
            <div class="submit" @click="addEvaluate()" v-if="evaluateObjVal">
                <span>提交</span>
            </div>
        </header-com>
        <div style="height:50px;width:100%;"></div>
        <div class="main-panel">
            <div style="margin:20px 0 40px 0">
                <van-row style="margin: 20px 0;">
                    <van-col span="8" v-for="(item,index) in list" v-bind:key="index">
                      <img :src="avadarPath[index][1]" @click="tofuck(item)" v-if="evaluateObjVal&&evaluateObjVal.id ==item.id" style="width: 50px;height: 50px;position: relative;top: 2px;" alt="">
                      <img  :src="avadarPath[index][0]" @click="tofuck(item)"  v-else style="width: 50px;height: 50px;position: relative;top: 2px;" alt="">
                    </van-col>
                    <!-- <van-col span="8">
                      <img src="/images/order/nothing.png" style="width: 40px;height: 40px;position: relative;top: 2px;" alt="">
                      <img src="/images/order/nothing-fc.png" style="width: 40px;height: 40px;position: relative;top: 2px;" alt="">
                    </van-col>
                    <van-col span="8">
                      <img src="/images/order/fuck.png" style="width: 40px;height: 40px;position: relative;top: 2px;" alt="">
                      <img src="/images/order/fuck-fc.png" style="width: 40px;height: 40px;position: relative;top: 2px;" alt="">
                    </van-col> -->
                </van-row>
                <van-row>
                    <van-col span="8" v-for="(item,index) in list"  @click="tofuck(item)" v-bind:key="index">{{item.name}}</van-col>
                    <!-- <van-col span="8">建议</van-col>
                    <van-col span="8">不满意</van-col> -->
                </van-row>
            </div>
            <div style="margin:30px 0" v-if="evaluateObjVal">
              <template v-for="(item,index) in evaluateObjVal.childTagBos">
                <van-tag class="no-chiose" @click="checks(item.id)" v-if="!item.flag" :key="index"> {{item.name}}</van-tag>
                <van-tag class="yes-chiose" @click="checks(item.id)" v-if="item.flag" :key="index"> {{item.name}}</van-tag>
                <!-- <span class="no-chiose" :key="index">
                  {{item}}
                </span> -->
              </template>
              
            </div>
            <van-field
              v-if="evaluateObjVal"
              v-model="parms.exaluateContent"
              rows="4"
              autosize
              label="留言"
              type="textarea"
              maxlength="200"
              placeholder="请输入留言"
              show-word-limit
            />
            <span class="text-fuck" v-if="evaluateObjVal">{{parms.exaluateContent.length}}/200</span>
             <div class="no-name-dfe" v-if="evaluateObjVal">
               <van-checkbox v-model="parms.anonymous" checked-color='#6DDEDE'>匿名评价</van-checkbox>
            </div>
            <div style="margin:40px 0" v-if="evaluateObjVal">
               <section class="uploadWrap">
                <ul  class="imageList">
                  <li v-for="(item,index) in imagesUrls" :key="index">
                    <img :src="item" alt="" />
                    <van-icon name="close" class="delete-img" @click="removeImg(index)" />
                  </li>
                  <li v-if="imagesUrls.length<3">
                    <upload-com @on-change='uploadChange'/>
                  </li>
                </ul>
              </section>
            </div>
        </div>
       
        <div class="width:100%;margin-top:50px">
            
        </div>
    </div>
</template>

<script>
  import orderApi from '@/axios/order'
  import { Toast } from 'vant';

  import publicObj from '@/assets/js/public';
  import QRCode from 'qrcode';
  export default {
    name: 'evaluate',
    components : {

    },
    data () {
      return {
        imagesUrls: [],
        imgList: [],
        evaluateObjVal:null,
        list:[],
        avadarPath:[
          [
            '/images/order/smil.png',
            '/images/order/smil-fc.png'
          ],
          [
            '/images/order/nothing.png',
            '/images/order/nothing-fc.png'
          ],
          [
            '/images/order/fuck.png',
            '/images/order/fuck-fc.png'
          ],
        ],
        parms:{
          evaluateLinkId:2,
          exaluateContent:'',
          anonymous:false,
          evaluateObjJsonVal:null
        },
        fileList: [
          {
            url: 'https://img.yzcdn.cn/vant/leaf.jpg',
            status: 'uploading',
            message: '上传中...',
          },
          {
            url: 'https://img.yzcdn.cn/vant/tree.jpg',
            status: 'failed',
            message: '上传失败',
          },
        ],
        tags:['修复效果很棒','修复速度快','服务流程很贴心','修复效果很棒','修复速度快','服务流程很贴心']
      }
    },
    computed: {
     
    },
    created () {
    //  this.code = this.$route.query.code;
     this.parms.orderCode  = this.$route.query.id;
     this.getDetail()
    },
    mounted () {
        
    },
    methods: {   
      uploadChange(data){
        this.imagesUrls.push(data.template);
        this.imgList.push(data.path);
      },
      checks(id){
        console.log(id)
        let lsit = this.evaluateObjVal.childTagBos
        this.evaluateObjVal.childTagBos = lsit.map(function(t){
            if(t.id==id){
              t.flag = !t.flag
            }
            return t
        })
      },
      tofuck(item){
        console.log(item)
        this.evaluateObjVal = item
      },
      removeImg (index) {
        this.imagesUrls.splice(index,1);
        this.imgList.splice(index,1);
      },
      aconfirm(){
       console.log(6666)
      },
      acencel(){
        console.log(77777)
      },
      getEvaluateParms(){
        // let evaluateObjVal = []
        // for(let obj of this.list){
        //   let temp = {
        //     evaluateScore:obj.evaluateScore,
        //     evaluateObjId:obj.id,
        //     evaluateObj:obj.name
        //   }
        //   let es = []
        //   for(let fc of obj.childTagBos){
        //     if(fc.flag){
        //       es.push(fc)
        //     }
        //   }
        //   temp.evaluateChildTags = es
        //   evaluateObjVal.push(temp)
        // }
        let parms = this.parms
        // parms.evaluateObjVal = this.evaluateObjVal
        let lsit = this.evaluateObjVal.childTagBos
        let array = []
        lsit.map(function(t){
            if(t.flag){
              array.push(t)
            }
        })
        // lsit.childTagBos = array
        // this.evaluateObjVal = lsit
        // parms.evaluateObjVal = lsit
        let temp = {
            evaluateScore:this.evaluateObjVal.evaluateScore,
            evaluateObjId:this.evaluateObjVal.id,
            evaluateObj:this.evaluateObjVal.name,
          }
        temp.childTagBos = array
        parms.evaluateObjJsonVal = {
          evaluateObjVal: [temp]
        }
        parms.photosPath = this.imgList
        return parms
      },
      addEvaluate(){
        let parms = this.getEvaluateParms()
        // parms.evaluateObjJsonVal.evaluateObjVal = this.getEvaluateParms()
        orderApi.addEvaluate(parms).then((res)=>{
          this.$router.push({name:'evaluateSuccess'})
          console.log(res) 
        })
        console.log(parms)
      },
      getDetail(){
        orderApi.searchTags(2).then((res)=>{
          this.list = res.map(function(obj){
            obj.evaluateScore =0
            obj.childTagBos = obj.childTagBos.map(function(t){
              t.flag = false
              return t
            })
            return obj
          })
          console.log(res)  
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.container{
    background-color:rgba(247, 247, 247, 1);
    padding: 0 0 50px 0;
    min-height: 1800px;
}
.headerCom {
  background: #fff;
}
.header{
    background-color: #fff;
}
.title-ds{
    text-align: center;
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 70px;
}
  .title{
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 100px;
  }
  .submit{
    width: 110px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background: #6DDEDE;
    border-radius: 4px;
    position: absolute;
    right: 60px;
    top: 24px;
    span{
        color:#fff;
    }
  }
  .main-panel{
      background-color: #fff;
      margin: 24px;
      width: calc(100% - 96px);
      padding:24px;
  }
  .start{
    width: 40px;
    height: 38px; 
    position: relative;
    top: 4px;
    margin:0 10px;
    // vertical-align:middle;
  }
  .name{
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 800;
    color: #1A1A1A;
    line-height: 20px;
    margin-right:100px;
  }
  .start-disc{
    float: right;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .start-tag{
    margin:10px 20px;
    padding: 5px 10px;
    height: 40px;
    background: #F5F5F5;
    border-radius: 4px;
  }
  .van-tag{
      padding: 8px 16px;
      margin: 10px 20px;
      // background-color:rgba(245, 245, 245, 1)!important;
      // color: rgba(102, 102, 102, 1)!important;
  }
  .bu-disc{
    width: calc(100% - 40px);
    height: 280px;
    background: #F7F7F7;
    border-radius: 4px;
    padding: 20px;
  }
  .text-fuck{
    font-size: 0.32rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    position: relative;
    left:calc(100% - 90px);
    top:-50px;
  }
.no-name-dfe{
    text-align: right;
    position: relative;
    top: -14px;
    font-size:10px
}
.van-col{
    text-align: center;
}
.animation{
  animation: wrapAnimation .8s ease-in-out forwards;
  textarea{animation: textareaAnimation .5s ease-in-out forwards;padding: 20px}
  textarea::-webkit-input-placeholder{font-size:28px;line-height:36px; }
  .num{animation: show .5s .8s ease-in-out forwards}
  .uploadWrap{animation: show .5s .8s ease-in-out forwards}
}
@keyframes wrapAnimation {
  0%{height: 128px;background-image: none}
  100%{height:630px;background-image: none}
}
@keyframes textareaAnimation {
  0%{margin: 18px 0 0 224px;background: $white-color}
  50%{width: 630px;height:50px;margin: 18px 0  60px 0;background: $border-color}
  100%{width: 630px;height: 260px;margin: 18px 0 60px 0;background: $border-color}
}
@keyframes show {
  0%{opacity: 0}
  100%{opacity: 1}
}
.uploadWrap{
  // opacity: 0;
  animation-delay: 2s;
  animation-duration:.3s;
  ul{
    display: flex;
  }
  li{
    width: 190px;
    height: 190px;
    position: relative;
    margin-right: 40px;
    img{
      width: 100%;
      height: 100%;
      &.delete-img{
        font-size: 40px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}
.no-chiose{
 
background: #F5F5F5!important;
  border-radius: 4px;
  padding: 1px 10px;
  line-height: 40px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin:20px;
} 
.yes-chiose{
  background: #b6e2e0f2!important;;
  border-radius: 4px;
  border: 1px solid #68DEDF;
   padding: 1px 10px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: #6DDEDE;
  margin:20px;
}
</style>
